import { SBox } from '@avalara/skylab-sdk/react';
import { Fragment } from 'react';

import styled from 'styled-components';

import { datesToRememberText } from '../constants';

const Wrapper = styled.div`
  display: inline-block;
  h2 {
    font-size: 23px;
    line-height: 30px;
  }
  p {
    color: var(--color-text-primary);
    font-size: 18px;
    line-height: 24px;
  }
`;

const DatesToRemember = () => {
  const { headingText, bullets } = datesToRememberText();
  return (
    <Wrapper>
      <SBox className='secondary pad-all-md pad-right-lg'>
        <h2 data-ref='buy.returns-thankyou.reminders.header'>{headingText}</h2>
        {bullets.map(({ dateRange, text, textSecondLine }, i) => (
          <Fragment key={text}>
            <p data-ref={`buy.returns-thankyou.reminders.${i}-dateRange`} className='font-bold pad-top-sm'>
              {dateRange}
            </p>
            <p data-ref={`buy.returns-thankyou.reminders.${i}-text`} className='pad-top-xs'>
              {text}
            </p>
            <p data-ref={`buy.returns-thankyou.reminders.${i}-textSecondLine`} className='pad-top-xs'>
              {textSecondLine}
            </p>
          </Fragment>
        ))}
      </SBox>
    </Wrapper>
  );
};

export default DatesToRemember;
